/* eslint react/no-multi-comp: 0 */

import * as React from "react";
import Autosuggest from "react-autosuggest";
import { connect } from "react-redux";

import { TextInput } from "@mantine/core";
import { bindActionCreators } from "redux";
import { getPersonsByAssociation } from "../../../data/actions/personActions";
import { IState } from "../../../data/reducers/state";
import { BasketballGrade } from "../../../types/common/basketballGrades";
import { IPerson } from "../../../types/persons/person";

const getSuggestionValue = (suggestion) =>
  suggestion.fullName ||
  `${suggestion.firstName} ${suggestion.lastName}` ||
  "Person";

const renderSuggestion = (person, { query, isHighlighted }) => {
  const grade =
    person.referee && person.referee.grade
      ? ` (${BasketballGrade.toShortString(person.referee.grade)})`
      : "";
  return person.fullName + grade;
};

const renderInput = ({ ...other }) => <TextInput {...other} />;

function renderSuggestionsContainer(options) {
  const { containerProps, children } = options;
  return (
    <div {...containerProps}>
      <div
        style={{
          zIndex: 999,
          overflow: "visible",
          position: "absolute",
          backgroundColor: "var(--color-bg-card)",
          border: "1px solid var(--color-divider)",
          borderRadius: "4px",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
          color: "var(--color-text-primary)"
        }}
      >
        {children}
      </div>
    </div>
  );
}

interface IPersonSearcherProps {
  id?: string | null;
  styles?: object | null;

  person: IPerson | null;
  persons: string[] | null;
  personMap: { [id: string]: IPerson };
  associationId?: string | null;

  personsFilter?: Function | null;
  personsToIgnore: Set<string> | null;

  onChange: Function;

  actions: {
    getPersonsByAssociation: Function;
  };
}

interface IPersonSearcherState {
  value: string;
  suggestions: IPerson[];
}

class PersonSearcher extends React.PureComponent<
  IPersonSearcherProps,
  IPersonSearcherState
> {
  constructor(props, content) {
    super(props, content);

    this.state = {
      value: this.props.person ? this.props.person.fullName : "",
      suggestions: [],
    };

    if (this.props.associationId)
      this.props.actions.getPersonsByAssociation(this.props.associationId);

    this.onChange = this.onChange.bind(this);
    this.getSuggestions = this.getSuggestions.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    this.onSuggestionsFetchRequested =
      this.onSuggestionsFetchRequested.bind(this);
    this.onSuggestionsClearRequested =
      this.onSuggestionsClearRequested.bind(this);
  }

  componentWillReceiveProps(newProps) {
    if (
      !this.props.person ||
      (newProps.person && newProps.person._id !== this.props.person._id)
    ) {
      const name = newProps.person ? newProps.person.fullName : "";
      this.setState({ ...this.state, value: name });
    }

    if (
      newProps.associationId &&
      this.props.associationId !== newProps.associationId
    ) {
      this.props.actions.getPersonsByAssociation(newProps.associationId);
    }
  }

  onChange(e, { newValue }) {
    this.setState((newState) => ({ ...newState, value: newValue }));
  }

  getSuggestions(query) {
    const q = query.trim().toLowerCase();
    const l = q.length;
    const maxLength = 5;

    let c = maxLength;
    let i = 0;
    const results: IPerson[] = [];

    const searchComponents = query.trim().toLowerCase().split(" ");
    const persons =
      this.props.persons ||
      (this.props.personsFilter && this.props.personsFilter());
    while (c > 0 && i < persons.length) {
      const p = this.props.personMap[persons[i]];
      i++;
      if (this.props.personsToIgnore && this.props.personsToIgnore.has(p._id))
        continue;

      let isValid = true;
      let queryIndex = 0;
      while (isValid && queryIndex < searchComponents.length) {
        const q = searchComponents[queryIndex];
        const l = q.length;
        queryIndex++;
        isValid =
          (p.preferredName &&
            p.preferredName.toLowerCase().slice(0, l) === q) ||
          p.firstName.toLowerCase().slice(0, l) === q ||
          p.lastName.toLowerCase().slice(0, l) === q ||
          (p.referee &&
            p.referee.id &&
            String(p.referee.id).slice(0, l) === q) ||
          false;
      }

      if (isValid) {
        results.push(p);
        c--;
      }
    }
    return results;
  }

  onSuggestionsFetchRequested(event) {
    this.setState({ suggestions: this.getSuggestions(event.value) });
  }

  onSuggestionsClearRequested() {
    this.setState((newState) => ({ ...newState, suggestions: [] }));
  }

  onSuggestionSelected(
    event,
    { suggestion, suggestionValue, suggestionIndex, sectionIndex, method },
  ) {
    this.setState({ ...this.state, value: "" });
    this.props.onChange(suggestion);
  }

  render() {
    const value = this.state.value || "";
    return (
      <Autosuggest
        fullWidth
        id={this.props.id || "person-search-cell"}
        // theme={{
        //   container: classes.container,
        //   suggestionsContainerOpen: classes.suggestionsContainerOpen,
        //   suggestionsList: classes.suggestionsList,
        //   suggestion: classes.suggestion,
        // }}
        renderInputComponent={renderInput}
        suggestions={this.state.suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        onSuggestionSelected={this.onSuggestionSelected}
        renderSuggestionsContainer={renderSuggestionsContainer}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        focusInputOnSuggestionClick={false}
        shouldRenderSuggestions={(_) => true}
        inputProps={{
          ...(this.props.styles || {}),
          placeholder: "Type a name...",
          value,
          onChange: this.onChange,
        }}
      />
    );
  }
}

function mapStateToProps(state: IState, ownProps) {
  return {
    persons: state.persons.byAssociation[ownProps.associationId],
    personMap: state.persons.map,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ getPersonsByAssociation }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonSearcher);
